module.exports = __webpack_public_path__ + "static/ncc-844ee7106befc1361e1ebd4d4132a6d2.png";